<section class="ecommerce-view-stats-wrapper">
  <div class="stat-items-wrapper">
    <div class="stat-item"
         *ngFor="let data of stat?.stats">
      <div class="item-label">{{data.label}}</div>
      <div class="item-value">{{data.value || '--'}}</div>
    </div>
  </div>
</section>
